<div class="container">
    <figure class="img-container">
        <img id="logo" [src]="companyLogoUrl$|async" alt="Loading logo" width="120px" height="120px"/>
    </figure>
    <span >{{ 'translations.loading' | translate }}<p class="line anim-typewriter">...</p></span>
</div>
